/* SegmentPersona Component Styles */

.persona-section {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid var(--gray-l);
}

.persona-header {
  margin-bottom: 16px;
}

.persona-title {
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: var(--gray-d);
}

.persona-description {
  font-size: 14px;
  line-height: 1.6;
  color: var(--gray-m);
  margin: 0;
}

.persona-field {
  margin-top: 20px;
}

.persona-field-label {
  display: block;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--gray-d);
}

/* Form / Edit Mode Styles */
.persona-editor-container {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.persona-editor-container > div:first-child {
  flex: 1;
}

.persona-edit-actions {
  display: flex;
  flex-direction: row;
  gap: 4px;
  padding-top: 4px;
}

/* Read-Only Mode Styles */
.persona-display-container {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.persona-content {
  flex: 1;
  background-color: var(--gray-xl);
  border: 1px solid var(--gray-l);
  border-radius: 4px;
  padding: 16px;
  min-height: 100px;
  font-size: 14px;
  line-height: 1.6;
  color: var(--gray-d);
}

/* Markdown content typography */
.persona-content p {
  margin: 0 0 8px 0;
}

.persona-content p:last-child {
  margin-bottom: 0;
}

.persona-content ul,
.persona-content ol {
  margin: 0 0 8px 0;
  padding-left: 24px;
}

.persona-content h1,
.persona-content h2,
.persona-content h3,
.persona-content h4,
.persona-content h5,
.persona-content h6 {
  margin: 0 0 8px 0;
  font-weight: 700;
}

.persona-content code {
  background-color: var(--gray-l);
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 13px;
}

.persona-content pre {
  background-color: var(--gray-l);
  padding: 12px;
  border-radius: 4px;
  overflow-x: auto;
}

.persona-content blockquote {
  border-left: 3px solid var(--gray-l);
  padding-left: 12px;
  margin: 0 0 8px 0;
  color: var(--gray-m);
}

/* Placeholder text styling */
.placeholder {
  color: var(--gray-m);
  font-style: italic;
}

/* Icon button for edit action */
.icon-button {
  border-radius: 50%;
  border: 2px solid transparent;
  padding: 5px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.icon-button:hover {
  border-color: var(--wl-icon-color, var(--pri-02));
  background-color: var(--wl-icon-color, var(--pri-02));
}

.icon-button:hover svg {
  color: var(--pri-01);
  fill: var(--pri-01);
}

.icon-button svg {
  color: var(--wl-icon-color, var(--pri-02));
  fill: var(--wl-icon-color, var(--pri-02));
  transition: all 0.2s ease-in-out;
}
